module.exports = __webpack_public_path__ + "img/violet_067.2e157dd9.png";